/**
 * @FileName : CodeDetailPage
 * @Description : This is system common code management detail page, parent page is CodePage
 * 
 * @author minjlee
 * @since 2023. 03.10
 * @version 0.1
 */

// MUI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import { red } from "@mui/material/colors";
import Checkbox from "@mui/material/Checkbox";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

//API
import { fni18n } from "../../services/commonService";

import { theme } from '../../assets/themes';

const CodeDetailPage = (props) => {
    return (
    <div className="pop-container">
        {/* 상단메뉴명 */}
        <div className="header">
            {fni18n('공통코드 설정')}
        </div>
        <div className="contents">
        <TableContainer className="table-container" component={Paper} elevation={0}>
            <Table className="table" size="small">
                <TableBody>
                <TableRow>
                    <TableCell className="table-cell-title">{fni18n('코드구분')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControl>
                            <TextField
                            type="text"
                            size="small"
                            hiddenLabel
                            placeholder="new"
                            name="cdGubn"
                            value={props.data.cdGubn || ""}
                            onChange={e => props.onChange(e)}
                            maxLength={3}
                            InputProps={{
                                maxLength: 3,
                            }}
                            error={props.showError && props.errors.cdGubn}
                            helperText={props.errors.cdGubn || ""}
                            />
                        </FormControl> 
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('코드번호')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControl>
                            <TextField
                            type="text"
                            size="small"
                            hiddenLabel
                            placeholder="new"
                            name="cd"
                            value={props.data.cd || ""}
                            onChange={e => props.onChange(e)}
                            InputProps={{
                                maxLength: 20,
                            }}
                            error={props.showError && props.errors.cd}
                            helperText={props.errors.cd || ""}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('코드명')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControl>
                            <TextField
                            type="text"
                            size="small"
                            hiddenLabel
                            placeholder=""
                            name="cdNm"
                            value={props.data.cdNm || ""}
                            onChange={e => props.onChange(e)}
                            InputProps={{
                                maxLength: 60,
                            }}
                            error={props.showError && props.errors.cdNm}
                            helperText={props.errors.cdNm || ""}
                            />
                        </FormControl>
                    </TableCell>
                </TableRow>
                <TableRow >
                    <TableCell className="table-cell-title">{fni18n('코드약어')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControl>
                            <TextField
                                type="text"
                                size="small"
                                hiddenLabel
                                name="cdShortNm"
                                value={props.data.cdShortNm || ""}
                                onChange={e => props.onChange(e)}
                                InputProps={{
                                    maxLength: 60,
                                }}
                                error={props.showError && props.errors.cdShortNm}
                                helperText={props.errors.cdShortNm || ""}
                            />
                    </FormControl>
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('코드길이')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControl>
                            <TextField
                            type="number"
                            size="small"
                            hiddenLabel
                            placeholder=""
                            name="cdLen"
                            value={props.data.cdLen || ""}
                            onChange={e => props.onChange(e)}
                            InputProps={{
                                maxLength: 2,
                            }}
                            error={props.showError && props.errors.cdLen}
                            helperText={props.errors.cdLen || ""}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('사용여부')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControlLabel
                        control={
                            <Checkbox
                            name="useYn"
                            checked={props.data.useYn === "Y" ? true : false}
                            onChange={e => props.onSwitchChange(e)}
                            />
                        }
                        />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell className="table-cell-title">{fni18n('설명')}</TableCell>
                    <TableCell className="table-cell" colSpan={5}>
                        <FormControl fullWidth>
                            <TextField
                            type="text"
                            size="small"
                            hiddenLabel
                            multiline
                            rows={1}
                            value={props.data.remk || ""}
                            name="remk"
                            onChange={e => props.onChange(e)}
                            InputProps={{
                                maxLength: 100,
                            }}
                            error={props.showError && props.errors.remk}
                            helperText={props.errors.remk || ""}
                            />
                        </FormControl>
                    </TableCell>
                </TableRow>
                </TableBody>            
            </Table>
        </TableContainer>
        </div>
    </div>
    )

}

export default CodeDetailPage;